import { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../../ThemeContext';

// assets
import Sparkle from "../../assets/icons/sparkle.svg";
import SparkleDark from "../../assets/icons/sparkle.svg";
import Private from "../../assets/icons/private.svg";
import PrivateDark from "../../assets/icons/private-dark.svg";

import InStore1 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-01.png"

function Product() {
    // const [osIndex, setOsIndex] = useState(0);
    // const osImages = [Othership2, Othership1, Othership3, Othership5, Othership4, Othership6]

    // const showPrevOsImage = () => {
    //     setOsIndex((prevIndex) => (prevIndex - 1 + osImages.length) % osImages.length);
    // };

    // const showNextOsImage = () => {
    //     setOsIndex((prevIndex) => (prevIndex + 1) % osImages.length);
    // };

    const { darkTheme } = useContext(ThemeContext);

    useEffect(() => {
        let sparkleImages = document.querySelectorAll('img[alt="Sparkle"]');
        let privateImages = document.querySelectorAll('img[alt="Private Case Study"]');

        if (darkTheme) {
            sparkleImages.forEach(img => img.src = SparkleDark);
            privateImages.forEach(img => img.src = PrivateDark);
        } else {
            sparkleImages.forEach(img => img.src = Sparkle);
            privateImages.forEach(img => img.src = Private);
        }
    }, [darkTheme]);

    return (
        <section className="design-projects">
            {/* Section Title */}
            <header className="mb-4 mb-md-5">
                <div className="d-flex mb-3">
                    <img src={darkTheme ? SparkleDark : Sparkle} alt="Sparkle" />
                    <h2>Product Design Work</h2>
                </div>
            </header>
            <section className="design-project-content">
                <section className="featured-items">
                    <div className="featured-images">
                        <Link to="/in-store">
                        <img src={InStore1} alt="Canadian Tire App Design" />
                        </Link>
                    </div>
                    <article>
                        <p className="cs-company">Canadian Tire</p>
                        <h3>Elevating the In-Store App Experience with a Smarter, Unified Approach</h3>
                        <p>App interface designed to integrate useful online shopping features and physical store enhancements to support users at every stage.</p>
                        <Link to="/in-store" className="button">
                        Read Case Study
                        </Link>
                    </article>
                </section>
            </section>
        </section>
    );
};

export default Product;